import { render } from "./orderHistory.vue?vue&type=template&id=6eaf8226&ts=true"
import script from "./orderHistory.vue?vue&type=script&lang=ts"
export * from "./orderHistory.vue?vue&type=script&lang=ts"

import "./orderHistory.vue?vue&type=style&index=0&id=6eaf8226&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__